<div class="page-container">
  <app-card>
    <app-card-content class="scrollable-content">
      <div class="dev-sql-header">
        <p class="warning">{{ 'dev.sql.warning' | translate }}</p>
        <div class="db-info">
          <strong>{{ 'dev.sql.customerId' | translate }}</strong> <code>{{ customerId }}</code><br>
          <strong>{{ 'dev.sql.database' | translate }}</strong> <code>{{ dbName }}</code>
        </div>
      </div>

      <div class="quick-queries">
        <h3>{{ 'dev.sql.quickQueries' | translate }}</h3>
        <button (click)="listTables()">{{ 'dev.sql.listTables' | translate }}</button>
        <button (click)="showOrganizations()">{{ 'dev.sql.organizations' | translate }}</button>
        <button (click)="showCheckPoints()">{{ 'dev.sql.assets' | translate }}</button>
        <button (click)="showSyncChanges()">Sync Log</button>
        <button (click)="showSchemaVersion()">Sync Tables</button>
      </div>

      <div class="query-editor">
        <label for="sql-query">{{ 'dev.sql.queryLabel' | translate }}</label>
        <textarea id="sql-query" [value]="query()" (input)="query.set($any($event.target).value)" rows="5"
          [placeholder]="'dev.sql.queryPlaceholder' | translate">
    </textarea>

        <label for="sql-params">Params (comma-separated, use ? in query):</label>
        <input id="sql-params" type="text" [value]="params()" (input)="params.set($any($event.target).value)"
          placeholder="e.g. J6l6zT95zWaGw6s5ySr8D, 42"
          style="width: 100%; padding: 0.5rem; font-family: monospace; margin-bottom: 0.5rem;">

        <button (click)="executeQuery()" [disabled]="executing()" class="execute-btn">
          {{ executing() ? ('dev.sql.executing' | translate) : ('dev.sql.execute' | translate) }}
        </button>
      </div>

      @if (error()) {
      <div class="error-box">
        <strong>{{ 'dev.sql.error' | translate }}</strong> {{ error() }}
      </div>
      }

      @if (success()) {
      <div class="success-box">
        {{ success() }}
      </div>
      }

      @if (results().length > 0) {
      <div class="results-container">
        <h3>{{ 'dev.sql.results' | translate:{count: results().length.toString()} }}</h3>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                @for (col of getColumns(); track col) {
                <th>{{ col }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of results(); track $index) {
              <tr>
                @for (col of getColumns(); track col) {
                <td>{{ formatValue(row[col]) }}</td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      } @else if (!error() && !executing()) {
      <div class="no-results">
        <p>{{ 'dev.sql.noResults' | translate }}</p>
      </div>
      }
    </app-card-content>
  </app-card>
</div>